<template>
  <div class="commentForm">
    <el-form :model="commentForm">
      <el-form-item label="">
        <el-input
          type="textarea"
          v-bind:placeholder="$t('commentPlaceholder')"
          v-model="commentForm.comment_content"
        ></el-input>
      </el-form-item>
      <el-form-item label="" class="short">
        <el-input v-model="commentForm.name" v-bind:placeholder="$t('name')"></el-input>
      </el-form-item>
      <el-form-item label="" class="short">
        <el-input v-model="commentForm.email" v-bind:placeholder="$t('email')"></el-input>
      </el-form-item>
      <el-button @click="submitComment(commentForm)" class="submit-btn" >{{ $t('submit') }}</el-button>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { validateEmail } from "../../config/validation";

export default {
  name: "commentForm",
  props: [
    'id',
    'location',
  ],
  data() {
    return {
      errors: [],
      commentForm: {
        comment_content: '',
        name: '',
        email: '',
      },
    }
  },
  methods: {
    ...mapActions('blog',['postBlogComment']),
    checkForm: async function (form) {
      this.errors = [];
      if(!form.comment_content) {
       this.errors.push('Comment is required')
      };
      if(!form.name) {
        this.errors.push('Name is required')
      };
      if(!form.email) {
        this.errors.push('Email is required')
      };
      if (validateEmail(form.email))(
        this.errors.push('Email has wrong format')
      );
    },
    submitComment(form){
      const location = this.$props.location; // check where the form at
      const id = this.$props.id;

      this.checkForm(form);
      if (!this.errors.length) {
        if (location === 'blog') {
          this.$store.dispatch('blog/postBlogComment', [form, id]);
        }
      } else {
        alert(this.errors);
      }
    }
  },
  mounted() {
  },
}
</script>

<style scoped lang="less">
// @import "../assets/css/public.less";
@import "../assets/css/commentForm.less";
</style>



// WEBPACK FOOTER //
// src/components/commentForm.vue